<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23 12.5001C23 18.2991 18.299 23.0001 12.5 23.0001C6.70101 23.0001 2 18.2991 2 12.5001C2 6.70113 6.70101 2.00012 12.5 2.00012C18.299 2.00012 23 6.70113 23 12.5001ZM8.00024 15.0001L14.0002 9.00012L16.0002 11.0001L10.0002 17.0001L8 17.0004L8.00024 15.0001ZM17.0002 10.0001L18.0002 9.00012L16.0002 7.00012L15.0002 8.00012L16.0002 9.00012L17.0002 10.0001Z"
      fill="#FFA500"
    />
  </svg>
</template>

<style scoped lang="postcss"></style>
